<template>
  <div class="order-status">
    <div class="stats-filter">
      <div class="flex items-center justify-between">
        <ul class="stats">
          <li
            v-for="item in stats"
            :key="item.status"
            @click="infinite.loading ? null : setStatus(item.status)"
          >
            <a :class="{ active: status == item.status }">
              {{ item.name }}
              <el-badge
                v-if="item.count"
                class="count"
                :type="status == item.status ? 'danger' : 'primary'"
                :value="item.count"
              />
            </a>
          </li>
        </ul>
        <div class="shrink-0 flex items-center gap-0.5">
          <div v-if="batchOrderSelected">
            <popup
              ref="batchEdit"
              className="font-bold no-underline mx-1 hidden"
              componentPath="pages/containers/replica"
              width="99%"
              height="100%"
              :pivot-y="0"
              :click-to-close="false"
              :options="batchOrderOptions"
            />
            <div class="batch-edit">
              <i class="el-icon-edit-outline px-1" />
              <el-dropdown v-if="!isEmptyData(importsToEdit)">
                <span class="el-dropdown-link text-xs">
                  IM: {{ importsToEdit.length }}
                  <i class="el-icon-arrow-down el-icon--right" />
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    @click.native="batchEdit('ImportContainer', importsToEdit)"
                  >
                    Batch Edit
                  </el-dropdown-item>
                  <el-dropdown-item
                    @click.native="copyBatchOrders(importsToEdit)"
                  >
                    Copy Numbers
                  </el-dropdown-item>
                  <el-dropdown-item
                    @click.native="clearBatchOrders(importsToEdit)"
                  >
                    Clear Selectors
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <el-dropdown v-if="!isEmptyData(exportsToEdit)">
                <span class="el-dropdown-link text-xs">
                  EX: {{ exportsToEdit.length }}
                  <i class="el-icon-arrow-down el-icon--right" />
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    @click.native="batchEdit('ExportContainer', exportsToEdit)"
                  >
                    Batch Edit
                  </el-dropdown-item>
                  <el-dropdown-item
                    @click.native="copyBatchOrders(exportsToEdit)"
                  >
                    Copy Numbers
                  </el-dropdown-item>
                  <el-dropdown-item
                    @click.native="clearBatchOrders(exportsToEdit)"
                  >
                    Clear Selectors
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <el-dropdown v-if="!isEmptyData(xtownsToEdit)">
                <span class="el-dropdown-link text-xs">
                  XT: {{ xtownsToEdit.length }}
                  <i class="el-icon-arrow-down el-icon--right" />
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    @click.native="batchEdit('XtownContainer', xtownsToEdit)"
                  >
                    Batch Edit
                  </el-dropdown-item>
                  <el-dropdown-item
                    @click.native="copyBatchOrders(xtownsToEdit)"
                  >
                    Copy Numbers
                  </el-dropdown-item>
                  <el-dropdown-item
                    @click.native="clearBatchOrders(xtownsToEdit)"
                  >
                    Clear Selectors
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
          <el-button v-if="total" size="mini" class="micro h-6">
            Total: {{ total }} <el-divider direction="vertical" /> Loaded:
            {{ items.length }} <el-divider direction="vertical" /> Filtered:
            {{ tableItems.length }}
          </el-button>
          <div v-if="status">
            <el-popover placement="left" width="300" trigger="click">
              <el-row :gutter="5">
                <el-col :span="24">
                  <label>
                    Columns: drag&sort
                    <el-button type="text" @click="resetColumns">
                      reset
                    </el-button>
                  </label>
                  <div class="max-h-[80vh] overflow-auto">
                    <draggable
                      v-model="columnOptions"
                      class="stripe"
                      draggable=".stripe-item"
                      ghost-class="ghost"
                      @change="moveColumn"
                    >
                      <div
                        v-for="column in columnOptions"
                        :key="column.name"
                        class="stripe-item"
                      >
                        <el-checkbox
                          v-model="column.visible"
                          :disabled="column.name == 'ID'"
                          @change="toggleColumn($event, column.name)"
                          >{{ column.name }}</el-checkbox
                        >
                      </div>
                    </draggable>
                  </div>
                </el-col>
                <el-col :span="12"> </el-col>
              </el-row>
              <el-button
                slot="reference"
                icon="el-icon-setting"
                size="mini"
                class="micro h-6"
              >
                Settings
              </el-button>
            </el-popover>
          </div>
          <a
            class="el-icon-question text-lg red mx-0.5"
            @click="EGuide.open('order-status')"
          />
        </div>
      </div>
      <div class="e-form">
        <el-form
          label-position="top"
          :inline="true"
          ref="form"
          size="mini"
          :model="filter"
          @keypress.enter.native="searchOrders"
        >
          <div class="flex items-center justify-between py-2">
            <div class="flex items-center gap-0.5">
              <div class="w-24 el-input-inner-label">
                <label v-if="!filter.hub_id_eq">Hub</label>
                <el-select
                  v-model="filter.hub_id_eq"
                  filterable
                  clearable
                  size="mini"
                  @keyup.enter.native="searchOrders"
                >
                  <el-option
                    v-for="item in options.hubs"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </div>
              <div class="w-36 el-input-inner-label">
                <label
                  v-if="!filter[isYard ? 'parking_yard_id_eq' : 'yard_id_eq']"
                  >Yard</label
                >
                <el-select
                  v-model="filter[isYard ? 'parking_yard_id_eq' : 'yard_id_eq']"
                  filterable
                  clearable
                  size="mini"
                  class="w-full"
                  @keyup.enter.native="searchOrders"
                >
                  <el-option-group key="yard" label="Yard">
                    <el-option
                      v-for="item in options.yards"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    />
                  </el-option-group>
                  <el-option-group key="place" label="Place">
                    <el-option
                      v-for="item in options.places"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    />
                  </el-option-group>
                </el-select>
              </div>
              <div v-if="completedStatus" class="w-72 el-input-inner-label">
                <label v-if="!filter.customer_id_eq">Customer</label>
                <el-select
                  v-model="filter.customer_id_eq"
                  filterable
                  clearable
                  size="mini"
                  class="w-full"
                  @keyup.enter.native="searchOrders"
                >
                  <el-option
                    v-for="item in options.customers"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  />
                </el-select>
                <el-checkbox
                  v-model="filter.customer_uninvoiced"
                  class="mini"
                  v-if="status == 'completed'"
                >
                  Uninvoiced
                </el-checkbox>
              </div>
              <div class="w-60 el-input-inner-label" v-else>
                <label v-if="!filter.customer_id_eq">Customer</label>
                <el-select
                  v-model="filter.customer_id_eq"
                  filterable
                  clearable
                  size="mini"
                  class="w-full"
                  @keyup.enter.native="searchOrders"
                >
                  <el-option
                    v-for="item in options.customers"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  />
                </el-select>
              </div>
              <div class="el-input-inner-label">
                <label>LFD<sup>IM</sup></label>
                <el-date-picker
                  size="mini"
                  v-model="filter.rail_lfd_eq"
                  type="date"
                  :format="'MM/dd'"
                  :value-format="'yyyy-MM-dd'"
                  style="width: 68px"
                />
              </div>
              <div class="el-input-inner-label">
                <label>COD<sup>EX</sup></label>
                <el-date-picker
                  size="mini"
                  v-model="filter.rail_cutoff_date_eq"
                  type="date"
                  :format="'MM/dd'"
                  :value-format="'yyyy-MM-dd'"
                  style="width: 68px"
                />
              </div>
              <div class="el-input-inner-label" v-if="forDelivered">
                <label>Delivered</label>
                <el-date-picker
                  size="mini"
                  v-model="filter.delivered_at_from"
                  type="date"
                  :format="'MM/dd'"
                  :value-format="'yyyy-MM-dd'"
                  style="width: 68px"
                />
                <el-date-picker
                  size="mini"
                  v-model="filter.delivered_at_to"
                  type="date"
                  :format="'MM/dd'"
                  :value-format="'yyyy-MM-dd'"
                  style="width: 68px"
                />
              </div>
              <div v-if="forEmptyReturned" class="el-input-inner-label">
                <label>Empty Returned</label>
                <el-date-picker
                  size="mini"
                  v-model="filter.empty_returned_at_from"
                  type="date"
                  :format="'MM/dd'"
                  :value-format="'yyyy-MM-dd'"
                  style="width: 68px"
                />
                <el-date-picker
                  size="mini"
                  v-model="filter.empty_returned_at_to"
                  type="date"
                  :format="'MM/dd'"
                  :value-format="'yyyy-MM-dd'"
                  style="width: 68px"
                />
              </div>
              <el-button type="primary" size="mini" @click="searchOrders"
                >Search</el-button
              >
              <el-button
                type="text"
                size="mini"
                @click="exportCsv"
                v-if="status != 'returned'"
              >
                Export to CSV
              </el-button>
            </div>
            <div class="flex items-center gap-1">
              <div v-if="isYard" class="yard-filter">
                <el-radio-group
                  v-model="yardFilter.view"
                  size="mini"
                  class="dense"
                  @change="storeYardView"
                >
                  <el-radio-button
                    label="asset"
                    @click.native.prevent.stop="
                      toggleYardFilter('view', 'asset')
                    "
                  >
                    <el-tooltip
                      content="Own Assets Only (Chassis, Trailer)"
                      placement="top"
                      :open-delay="1000"
                    >
                      <span>Asset</span>
                    </el-tooltip>
                  </el-radio-button>
                  <el-radio-button
                    label="other"
                    @click.native.prevent.stop="
                      toggleYardFilter('view', 'other')
                    "
                  >
                    <el-tooltip
                      content="Third Party Equipment"
                      placement="top"
                      :open-delay="1000"
                    >
                      <span>Other</span>
                    </el-tooltip>
                  </el-radio-button>
                </el-radio-group>
                <el-radio-group
                  v-model="yardFilter.status"
                  size="mini"
                  class="dense yard-icons"
                >
                  <el-radio-button
                    v-for="item in yardStatusSummaries"
                    :key="item.status"
                    :label="item.status"
                    class="icon"
                    @click.native.prevent.stop="
                      toggleYardFilter('status', item.status)
                    "
                  >
                    <el-tooltip
                      :content="item.label"
                      placement="top"
                      :open-delay="1000"
                    >
                      <div class="flex items-center gap-1">
                        <img :src="item.icon" />
                        <div class="qty" v-if="item.count > 0">
                          {{ item.count }}
                        </div>
                      </div>
                    </el-tooltip>
                  </el-radio-button>
                </el-radio-group>
                <el-button
                  v-if="yardFilterResetable"
                  type="danger"
                  size="mini"
                  class="micro"
                  @click="resetYardFilter"
                >
                  Reset
                </el-button>
              </div>
              <div class="relative w-36">
                <el-input
                  clearable
                  placeholder="Quick Table Filter"
                  v-model.lazy="keyword"
                  size="mini"
                >
                  <i slot="prefix" class="el-input__icon el-icon-s-grid" />
                </el-input>
                <div
                  class="absolute -bottom-1 right-0 text-2xs font-bold red"
                  v-if="onQuickFilter"
                >
                  Auto load more is disabled
                </div>
              </div>
            </div>
          </div>
        </el-form>
      </div>
    </div>
    <ContainerOrderStatusTable
      ref="table"
      :items="tableItems"
      :status="status"
      @loadMore="loadMore"
      @initColumnOptions="initColumnOptions"
    />
  </div>
</template>
<script>
import api from "@/default/utils/api";
import ContainerOrderStatusTable from "@/default/pages/containers/order_status/table.vue";
import { getInYardSvgUrl } from "@/default/utils/svgs";
export default {
  name: "ContainerOrderStatus",
  mixins: [api],
  components: {
    ContainerOrderStatusTable,
  },
  data() {
    return {
      status: null,
      csv: false,
      filter: {
        delivered_at_from: null,
        delivered_at_to: null,
        empty_returned_at_from: null,
        empty_returned_at_to: null,
        customer_uninvoiced: true,
      },
      yardFilter: {
        view: null,
        status: null,
      },
      stats: [],
      total: null,
      items: [],
      options: {},
      keyword: "",
      infinite: {
        page: 1,
        loading: false,
        last: false,
      },
      columnOptions: [],
      batchOrderOptions: {},
      fuseOptions: {
        shouldSort: true,
        threshold: 0.25,
        location: 0,
        distance: 100,
        maxPatternLength: 32,
        minMatchCharLength: 1,
        keys: [
          "id",
          "hub.name",
          "container_no",
          "chassis_no",
          "operation.container_no",
          "operation.chassis_no",
          "terminals",
          "yards",
          "ssline.name",
          "customer.name",
          "clients.name",
          "clients.city",
          "transports.trucker.name",
          "yard.status",
        ],
      },
    };
  },
  mounted() {
    window.ContainerOrderStatus = { receive: this.receive };
    window.addEventListener("container-colorify", this.colorify);
  },
  async created() {
    this.initYardViewFromStorage();
    await this.loadOptions();
    await this.loadStats();
    await this.loadOrders();
  },
  beforeDestroy() {
    this.items = [];
    window.removeEventListener("container-colorify", this.colorify);
  },
  computed: {
    vetable() {
      return this.$refs.table.$refs.table;
    },
    isYard() {
      return this.status == "yard";
    },
    completedStatus() {
      return this.status == "completed";
    },
    onQuickFilter() {
      return this.keyword.trim().length > 0;
    },
    filteredItems() {
      let items = this.isYard ? this.filteredYardItems : this.items;
      const term = this.keyword.trim();
      if (term.length >= 3) {
        items = this.$search(term, items, this.fuseOptions).map((o) => o.item);
      }
      return items;
    },
    tableItems() {
      if (!this.isYard || !this.yardFilter.status) return this.filteredItems;
      return this.filteredItems.filter(
        (item) =>
          item.operation && item.operation.status == this.yardFilter.status,
      );
    },
    filteredYardItems() {
      switch (this.yardFilter.view) {
        case "asset":
          return this.items.filter(
            (o) =>
              (o.operation.chassis_own &&
                this.isEmptyData(o.operation.container_no)) ||
              (o.operation.trailer_own &&
                !this.isEmptyData(o.operation.container_no)),
          );
        case "other":
          return this.items.filter(
            (o) => o.operation.container_no || !o.operation.chassis_own,
          );
        default:
          return this.items;
      }
    },
    yardFilterResetable() {
      return this.yardFilter.view || this.yardFilter.status;
    },
    yardStatusSummaries() {
      const icons = getInYardSvgUrl();
      const counts = {};
      this.filteredItems.forEach((item) => {
        const status = item.operation && item.operation.status;
        if (!icons[status]) return;
        counts[status] = (counts[status] || 0) + 1;
      });
      return Object.keys(icons).map((status) => ({
        status,
        icon: icons[status],
        label: status.titleize(),
        count: counts[status] || 0,
      }));
    },
    orderSameHub() {
      return function (item) {
        return this.options.hubs.map((o) => o.id).includes(item?.hub?.id);
      };
    },
    forDelivered() {
      return ["delivered", "on_site", "yard", "completed"].includes(
        this.status,
      );
    },
    forEmptyReturned() {
      return ["completed"].includes(this.status);
    },
    importsToEdit() {
      return this.items.filter(
        (o) => o.editing && o.type === "ImportContainer",
      );
    },
    exportsToEdit() {
      return this.items.filter(
        (o) => o.editing && o.type === "ExportContainer",
      );
    },
    xtownsToEdit() {
      return this.items.filter((o) => o.editing && o.type === "XtownContainer");
    },
    batchOrderSelected() {
      return (
        this.importsToEdit.length > 0 ||
        this.exportsToEdit.length > 0 ||
        this.xtownsToEdit.length > 0
      );
    },
  },
  methods: {
    initYardViewFromStorage() {
      this.yardFilter.view = this.getSettings("orderStatusYardView", null);
    },
    initColumnOptions() {
      if (!this.status) return;
      this.columnOptions = this.getTableColumns(`order-status-${this.status}`);
    },
    resetColumns() {
      this.$actions.updateTableColumns({ [`order-status-${this.status}`]: [] });
      this.$refs.table.initCachedColumns();
    },
    toggleColumn(checked, name) {
      this.updateTableColumn(`order-status-${this.status}`, name, {
        visible: checked,
      });
    },
    moveColumn() {
      this.columnOptions.forEach((column, index) => {
        column.order = index + 1;
      });
      this.$actions.updateTableColumns({
        [`order-status-${this.status}`]: this.columnOptions,
      });
    },
    async loadOptions() {
      try {
        let response = await this.$http.get("/api/v1/hubs");
        this.$set(this.options, "hubs", response.data);
        response = await this.$http.get("/api/v1/options.json", {
          params: { targets: ["customers"] },
        });
        this.$set(this.options, "customers", response.data.customers);
        response = await this.$http.get("/api/v1/options.json", {
          params: { targets: ["places", "yards"], active: true },
        });
        this.$set(this.options, "yards", response.data.yards);
        this.$set(this.options, "places", response.data.places);
      } catch (ex) {}
    },
    async loadStats() {
      try {
        const response = await this.$http.get("/api/v1/containers/at_status", {
          params: { stats: true },
        });
        this.stats = response.data;
      } catch (ex) {}
    },
    async loadOrders(concat = false) {
      try {
        this.vetable.loading();
        this.infinite.loading = true;
        const q = this.statusQuery();
        const response = await this.$http.get("/api/v1/containers/at_status", {
          params: { q, status: this.status, page: this.infinite.page },
        });

        this.infinite.loading = false;
        this.status = response.data.status;
        this.total = response.data.total;
        const { current_page, page_size, total } = response.data;
        this.vetable.setPagingInfo({
          pageSize: page_size,
          currentPage: current_page,
          total: total,
        });

        const index = this.stats.findIndex((o) => o.status == this.status);
        if (index >= 0) this.stats[index].count = total;

        const containers = response.data.containers;
        if (containers.length > 0) {
          const newItems = this.processItems(containers);
          if (concat) {
            this.items = this._.concat(this.items, newItems);
          } else {
            this.items = newItems;
          }
        } else {
          this.infinite.last = true;
        }
      } catch (err) {
        this.$message({ message: err.response.data.errors, type: "error" });
      } finally {
        this.vetable.loaded();
      }
    },
    exportCsv() {
      this.getDownload("/api/v1/containers/at_status.csv", {
        q: this.statusQuery(),
        status: this.status,
      });
    },
    async loadMore() {
      if (
        !this.onQuickFilter &&
        !this.infinite.loading &&
        !this.infinite.last
      ) {
        this.infinite.page += 1;
        await this.loadOrders(true);
      }
    },
    resetYardFilter() {
      this.yardFilter.view = null;
      this.yardFilter.status = null;
      this.storeYardView();
    },
    toggleYardFilter(key, value) {
      this.yardFilter[key] = this.yardFilter[key] === value ? null : value;
      if (key == "view") this.storeYardView();
    },
    statusQuery() {
      const q = { ...this.filter };
      if (!this.forDelivered) {
        delete q.delivered_at_from;
        delete q.delivered_at_to;
      }
      if (!this.forEmptyReturned) {
        delete q.empty_returned_at_from;
        delete q.empty_returned_at_to;
      }
      if (this.isYard) {
        delete q.yard_id_eq;
      } else {
        delete q.parking_yard_id_eq;
      }
      if (!this.completedStatus) {
        delete q.customer_uninvoiced;
      }
      return q;
    },
    async setStatus(status) {
      this.items = [];
      setTimeout(async () => {
        this.status = status;
        await this.searchOrders();
      }, 50);
    },
    async searchOrders() {
      this.infinite.page = 1;
      this.infinite.last = false;
      this.items = [];
      await this.loadOrders();
    },
    processItems(items) {
      return items.map((item) => this.processItem(item));
    },
    processItem(item) {
      item.transports = item.transports || [];
      const routes = item.transports;
      const cs = this._.uniqBy(
        this._.flatten(routes.map((o) => o.operations.map((o) => o.company))),
        "id",
      );
      const terminals = cs.filter((o) => ["Terminal"].includes(o.type));
      const yards = cs.filter((o) => ["Place", "Yard"].includes(o.type));
      const clients = cs.filter((o) => ["Warehouse"].includes(o.type));
      item.terminals = terminals.map((o) => o.name).join(";");
      item.yards = yards.map((o) => o.name).join(";");
      item.clients = {
        name: clients.map((o) => o.name).join(";"),
        city: clients.map((o) => o.city).join(";"),
        state: clients.map((o) => o.state).join(";"),
      };
      item.dfactor = this._.map(routes, "trucker.name")
        .filter((n) => n)
        .join("0")
        .toLowerCase();
      return item;
    },
    receive(data) {
      const item = data.statuses.find((o) => o.status == this.status);
      if (!this.orderSameHub(item)) return;
      if (item && this.agentScoped(item.agent_id)) {
        item.mounted = true;
        this.processItem(item);
        let index = this.items.findIndex((o) => o.id == item.id);
        if (index >= 0) {
          item.editing = this.items[index].editing;
          this.items.splice(index, 1, item);
        } else {
          this.items.push(item);
        }
      } else {
        let index = this.items.findIndex((o) => o.id == data.id);
        if (index >= 0) this.items.splice(index, 1);
      }
    },
    colorify(event) {
      const { id, color } = event.detail;
      const item = this.items.find((item) => item.id === id);
      if (item) this.$set(item, "color", color);
    },
    storeYardView() {
      this.updateSettings({ orderStatusYardView: this.yardFilter.view });
    },
    batchEdit(type, orders) {
      const ids = orders.map((o) => o.id);
      this.batchOrderOptions = { mode: "edit", master: { type }, ids };
      this.$refs.batchEdit.open();
    },
    copyBatchOrders(orders) {
      const numbers = orders
        .map((o) => o.container_no || o.operation?.container_no)
        .filter((n) => !this.isEmptyData(n))
        .join("\n");
      this.$copyText(numbers).then(
        (e) => {
          this.$message({
            message: "Container numbers are copied to clipboard",
            type: "success",
          });
        },
        (e) => {},
      );
    },
    clearBatchOrders(orders) {
      orders.forEach((o) => {
        this.$set(o, "editing", false);
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.order-status::v-deep {
  @apply h-full pt-1;
  .stats-filter {
    @apply h-20;
  }
  .batch-edit {
    @apply empty:hidden border bg-white h-6 px-1 rounded flex items-center divide-x;
    & > div {
      @apply px-1;
    }
  }
  .yard-filter {
    @apply flex items-center gap-0.5 border border-gray-300 px-0.5  bg-white rounded-md;
    .el-radio-group {
      .el-radio-button--mini {
        .el-radio-button__inner {
          @apply relative py-1 h-[22px];
          .qty {
            @apply text-2xs;
          }
          img {
            @apply h-5 w-auto -mt-1;
          }
        }
      }
    }
  }
  ul.stats {
    @apply flex flex-nowrap items-center gap-0.5 overflow-x-auto bg-white border-b-gray-300 h-7;
    li {
      @apply shrink-0;
      a {
        @apply text-xs tracking-tight border border-gray-400 rounded-t-md bg-white no-underline py-1 pl-1.5 pr-3 text-gray-600;
        &.active {
          @apply text-white font-bold bg-blue-500;
        }
        .count {
          @apply ml-0.5 -mr-2.5;
          .el-badge__content {
            @apply -top-0.5 text-xs px-1 #{!important};
          }
        }
      }
    }
  }
}
</style>
